module.exports = __webpack_public_path__ + "img/relative-relation.ca4c550e.svg";